import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(8),
        borderTop: '1px solid #D2DAE4',
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(4)
    }
}))

export default useStyles
